import { DomainError } from '../../domain.js';
export class InvalidSortError extends DomainError {
  static create(msg) {
    return new InvalidSortError(msg);
  }

}